/* Family Care Office — "Getting Ready for Care" shared Placement record.
   Field keys MUST match backend/care_placement_info.py exactly. */

export const CARE_INFORMATION_FIELDS = [
  { key: "preferred_name", label: "Preferred name & how they like to be addressed", type: "text" },
  { key: "communication_needs", label: "Communication needs", type: "textarea" },
  { key: "health_conditions", label: "Relevant health conditions", type: "textarea" },
  { key: "mobility_transfers_equipment", label: "Mobility, transfers and equipment", type: "textarea" },
  { key: "personal_care_support", label: "Personal-care support", type: "textarea" },
  { key: "eating_drinking_allergies", label: "Eating, drinking and allergies", type: "textarea" },
  { key: "medication_support_info", label: "Medication-support information", type: "textarea" },
  { key: "routines_preferences", label: "Usual routines and preferences", type: "textarea" },
  { key: "known_risks", label: "Known risks or important safety information", type: "textarea" },
  { key: "distressing_or_reassuring", label: "Anything they find distressing or reassuring", type: "textarea" },
];

export const HOME_PRACTICAL_FIELDS = [
  { key: "care_address", label: "Care address", type: "text" },
  { key: "arrival_access_instructions", label: "Arrival and access instructions", type: "textarea" },
  { key: "key_safe_info", label: "Key-safe information (optional)", type: "text" },
  { key: "parking_transport", label: "Parking or transport information", type: "textarea" },
  { key: "live_in_accommodation", label: "Live-in accommodation details (where relevant)", type: "textarea" },
  { key: "bathroom_kitchen", label: "Bathroom and kitchen arrangements", type: "textarea" },
  { key: "pets", label: "Pets", type: "text" },
  { key: "smoking", label: "Smoking", type: "text" },
  { key: "wifi_details", label: "Wi-Fi details (optional)", type: "text" },
  { key: "equipment_supplies", label: "Equipment and supplies", type: "textarea" },
  { key: "household_routines_boundaries", label: "Household routines or important boundaries", type: "textarea" },
];

export const EMERGENCY_CONTACTS_FIELDS = [
  { key: "primary_family_contact", label: "Primary family contact", type: "text" },
  { key: "alternative_emergency_contact", label: "Alternative emergency contact", type: "text" },
  { key: "gp_details", label: "GP", type: "text" },
  { key: "pharmacy_details", label: "Pharmacy", type: "text" },
  { key: "other_professionals", label: "Other relevant professionals", type: "textarea" },
  { key: "preferred_hospital", label: "Preferred hospital (if applicable)", type: "text" },
  { key: "emergency_escalation_instructions", label: "Emergency / escalation instructions", type: "textarea" },
  { key: "allergies_critical_alerts", label: "Allergies and critical safety alerts", type: "textarea" },
  { key: "important_documents_location", label: "DNACPR / Power of Attorney / other important documents — do they exist, and where can the authorised carer find them", type: "textarea" },
];

export const STARTING_CARE_FIELDS = [
  { key: "expected_start_date", label: "Expected start date", type: "text" },
  { key: "first_arrival_arrangements", label: "First-arrival arrangements", type: "textarea" },
  { key: "initial_handover_provider", label: "Who will provide the initial handover", type: "text" },
  { key: "recent_changes_to_know", label: "Current or recent changes the incoming carer should know", type: "textarea" },
  { key: "outstanding_appointments_actions", label: "Outstanding appointments or actions", type: "textarea" },
  { key: "essential_supplies_location", label: "Location of essential supplies and records", type: "textarea" },
  { key: "contingency_backup_contact", label: "Contingency / backup contact if planned care cannot proceed", type: "text" },
  { key: "additional_starting_notes", label: "Additional starting notes", type: "textarea" },
];

export const PLACEMENT_INFO_SECTIONS = [
  {
    key: "care_information",
    label: "Important Care Information",
    fields: CARE_INFORMATION_FIELDS,
    note: "This supports practical care preparation. It does not replace professional medical advice, prescriptions, MAR records or formal care plans where those are required.",
  },
  {
    key: "home_practical",
    label: "Home & Practical Information",
    fields: HOME_PRACTICAL_FIELDS,
    note: null,
  },
  {
    key: "emergency_contacts",
    label: "Emergency & Important Contacts",
    fields: EMERGENCY_CONTACTS_FIELDS,
    note: "Recording that a document exists here is not legal or clinical verification of it.",
  },
  {
    key: "starting_care",
    label: "Starting Care & Handover",
    fields: STARTING_CARE_FIELDS,
    note: null,
  },
];

export const SECTION_STATUS_LABEL = {
  not_started: "Not started",
  in_progress: "In progress",
  complete: "Complete",
};

export const SECTION_STATUS_CLASS = {
  not_started: "bg-slate-100 text-ink-muted",
  in_progress: "bg-amber-50 text-amber-700",
  complete: "bg-teal-50 text-teal",
};
